/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Select_Next_EventInputs */



/**
* | output |
* | --- |
* | "Selects the next event closest to the current player time" |
*
* @param {Shortcut_Keys_Desc_Timeline_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_select_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement suivant le plus proche du temps de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählt das nächste Ereignis aus, das der aktuellen Spielerzeit am nächsten liegt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'evento successivo più vicino all'orario corrente del giocatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбирает следующее событие, ближайшее к текущему времени игрока.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selecciona el próximo evento más cercano a la hora actual del jugador.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择距离玩家当前时间最近的下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のプレイヤー時間に最も近い次のイベントを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान खिलाड़ी के समय के सबसे नजदीक अगली घटना का चयन करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleciona o próximo evento mais próximo do horário atual do jogador.")
	return /** @type {LocalizedString} */ ("Selects the next event closest to the current player time")
});